import { dealError } from './dealError';

type Message = string | null;
type Callback = (dealError: any) => Message;
type Reducer = (message: Message, callback: Callback) => Message;

const dealErrorHasSpecificCode = (dealErrorObject: any) => {
  if (dealError.dealIsExpired(dealErrorObject)) {
    return 'spc.customise.error.expiredDeal';
  }

  return null;
};

const genericDealError = (dealErrorObject: any) => {
  if (dealErrorObject && !dealError.dealerNotFoundOnDeal(dealErrorObject)) {
    return 'spc.customise.error.generalDeal';
  }

  return null;
};

const handleDealError = (dealErrorObject: any, ...callbacks: Array<(dealErrorObject: any) => Message>) => {
  const reducer: Reducer = (message, callback) => {
    if (message === null) {
      return callback(dealErrorObject);
    }

    return message;
  };

  return callbacks.reduce<Message>(reducer, null);
};

export const stickyError = {
  generateStickyErrorMessage: (dealErrorObject: any) => {
    return handleDealError(dealErrorObject, dealErrorHasSpecificCode, genericDealError);
  },
};
